export const ErrorMessage = {
    NOT_FOUND: 'NOT_FOUND',
    BAD_REQUEST: 'BAD_REQUEST',
    UNPROCESSABLE_ENTITY: 'UNPROCESSABLE_ENTITY',
    JWT_ERROR: 'JWT_ERROR',
    UNAUTHORIZED: 'UNAUTHORIZED',
    MALFORMED_TOKEN: 'MALFORMED_TOKEN'
};
